(function () {
  function initArandoHomeAnchors() {
    document.querySelectorAll('.arando-home-hero a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;

        event.preventDefault();
        var header = document.querySelector('.site-header');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        var offset = headerHeight;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArandoHomeAnchors);
  } else {
    initArandoHomeAnchors();
  }
})();
